import React, { ReactElement } from 'react';
import { space } from '@op/opds.tokens';
import { Message, useMessage } from '@messageformat/react';
import CourseTaskHeader from '../CourseTaskHeader';
import DiversityAnalyzer from './DiversityAnalyzer/DiversityAnalyzer';
import { optionsDomestic, optionsForeign } from './DiversityAnalyzer/options';
import CourseContent from '../CourseContent';
import parseMsgContent from '../../util/parseMsgContent';

const TaskTwo = (): ReactElement => {
  const taskTwoBody = useMessage('course7.task2.body');
  const parsedTaskTwoBody = parseMsgContent(taskTwoBody);
  return (
    <div style={{ marginBottom: space.xl }}>
      <CourseTaskHeader questionNumber={2} totalQuestions={3} />
      <h3
        className="opds-styles-v1-text-hero-small"
        style={{ textAlign: 'center', marginTop: space.xxl, marginBottom: space.default }}
      >
        <Message id="course7.task2.title" />
      </h3>

      <CourseContent content={parsedTaskTwoBody} />

      <DiversityAnalyzer options={[...optionsDomestic, ...optionsForeign]} type="STOCK" />
    </div>
  );
};

export default TaskTwo;
